// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    url: "https://m.media-amazon.com/images/M/MV5BNWM0ZGJlMzMtZmYwMi00NzI3LTgzMzMtNjMzNjliNDRmZmFlXkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UX280_CR0,0,280,414_.jpg",
    rating: 7.3,
    desc: "Doctor Strange in the Multiverse of Madness",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BYTdiOTIyZTQtNmQ1OS00NjZlLWIyMTgtYzk5Y2M3ZDVmMDk1XkEyXkFqcGdeQXVyMTAzMDg4NzU0._V1_QL75_UY414_CR3,0,280,414_.jpg",
    rating: 7.3,
    desc: "Everything Everywhere All at Once",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BMzVlMmY2NTctODgwOC00NDMzLWEzMWYtM2RiYmIyNTNhMTI0XkEyXkFqcGdeQXVyNTAzNzgwNTg@._V1_QL75_UX280_CR0,0,280,414_.jpg",
    rating: 7.3,
    desc: "The Northman",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BMDdmMTBiNTYtMDIzNi00NGVlLWIzMDYtZTk3MTQ3NGQxZGEwXkEyXkFqcGdeQXVyMzMwOTU5MDk@._V1_QL75_UX280_CR0,0,280,414_.jpg",
    rating: 7.3,
    desc: "The Batman",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BYTc5OWNhYjktMThlOS00ODUxLTgwNDQtZjdjYjkyM2IwZTZlXkEyXkFqcGdeQXVyNTA3MTU2MjE@._V1_QL75_UX280_CR0,0,280,414_.jpg",
    rating: 7.3,
    desc: "The Moonight",
  },
  {
    url: "https://m.media-amazon.com/images/M/MV5BZjBlMjIxN2ItNTMyNi00NDk5LWFhMzEtNzdiODE0Y2M4MWI2XkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UY414_CR2,0,280,414_.jpg",
    rating: 4.5,
    desc: "Chip 'n Dale: Rescue Rangers",
  },
];
